import { mapValues } from '../utils/mapValues';
const toDomain = backofficeContentComponent => {
  if (backofficeContentComponent.text !== undefined) {
    return backofficeContentComponent.text;
  }
  if (backofficeContentComponent.number !== undefined) {
    return backofficeContentComponent.number;
  }
  if (backofficeContentComponent.boolean !== undefined) {
    return backofficeContentComponent.boolean;
  }
  if (backofficeContentComponent.date) {
    return backofficeContentComponent.date;
  }
  if (backofficeContentComponent.choiceQuestion) {
    return {
      questionKey: backofficeContentComponent.choiceQuestion.questionKey,
      content: mapValues(backofficeContentComponent.choiceQuestion.content, contentComponentMapper.toDomain),
      options: backofficeContentComponent.choiceQuestion.options.map(option => ({
        optionKey: option.optionKey,
        ...mapValues(option.content, contentComponentMapper.toDomain)
      }))
    };
  }
  if (backofficeContentComponent.freeTextQuestion) {
    return {
      questionKey: backofficeContentComponent.freeTextQuestion.questionKey,
      content: mapValues(backofficeContentComponent.freeTextQuestion.content, contentComponentMapper.toDomain)
    };
  }
  if (backofficeContentComponent.list) {
    return {
      items: backofficeContentComponent.list.values.map(option => ({
        ...mapValues(option.content, contentComponentMapper.toDomain)
      }))
    };
  }
  if (backofficeContentComponent.group) {
    return {
      content: mapValues(backofficeContentComponent.group.content, contentComponentMapper.toDomain)
    };
  }
  throw new Error('unsupported type');
};
export const contentComponentMapper = {
  toAPI: () => {
    throw new Error('not implemented: contentMapper#toAPI');
  },
  toDomain
};
//# sourceMappingURL=content.mapper.js.map